
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.09 1C7.997 2.397 5.349 4.876 3.508 8.099 1.667 11.32.725 15.129.811 19c-.086 3.872.856 7.68 2.696 10.901 1.84 3.223 4.49 5.702 7.584 7.099","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"16.091","cy":"12","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"20.091","cy":"12","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"24.091","cy":"12","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"16.091","cy":"26","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"20.091","cy":"26","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"24.091","cy":"26","r":"1","fill":"currentColor"}}),_c('path',{attrs:{"d":"M29.09 37c3.095-1.397 5.744-3.876 7.584-7.099 1.84-3.222 2.783-7.03 2.697-10.901.086-3.871-.856-7.68-2.697-10.901-1.84-3.223-4.489-5.702-7.583-7.099","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    